export class RestoreObfuscationConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "mode",
            "baseName": "mode",
            "type": "RestoreObfuscationConfigModeEnum",
            "format": ""
        },
        {
            "name": "categories",
            "baseName": "categories",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreObfuscationConfig.attributeTypeMap;
    }
    constructor() {
    }
}
export var RestoreObfuscationConfigModeEnum;
(function (RestoreObfuscationConfigModeEnum) {
    RestoreObfuscationConfigModeEnum["Mask"] = "MASK";
    RestoreObfuscationConfigModeEnum["Zero"] = "ZERO";
    RestoreObfuscationConfigModeEnum["Fake"] = "FAKE";
})(RestoreObfuscationConfigModeEnum || (RestoreObfuscationConfigModeEnum = {}));
